import React from 'react';

interface NoMoneyIconProps {
  wrapperClassName?: string;
  pathClassName?: string;
}

const NoMoneyIcon = ({ wrapperClassName, pathClassName }: NoMoneyIconProps) => (
  <svg
    className={wrapperClassName}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        className={pathClassName}
        d="M13.825 7.7C13.5917 7.46667 13.3333 7.28333 13.05 7.15C12.7667 7.01667 12.4333 6.95 12.05 6.95C11.75 6.95 11.4583 6.99167 11.175 7.075C10.8917 7.15833 10.6333 7.31667 10.4 7.55L8.95001 6.1C9.18335 5.86667 9.50001 5.65433 9.90001 5.463C10.3 5.271 10.6667 5.15 11 5.1V4C11 3.71667 11.096 3.479 11.288 3.287C11.4793 3.09567 11.7167 3 12 3C12.2833 3 12.521 3.09567 12.713 3.287C12.9043 3.479 13 3.71667 13 4V5.05C13.5833 5.16667 14.104 5.375 14.562 5.675C15.0207 5.975 15.4167 6.35833 15.75 6.825C15.9167 7.05833 15.946 7.30833 15.838 7.575C15.7293 7.84167 15.5333 8.04167 15.25 8.175C15.0167 8.25833 14.775 8.25833 14.525 8.175C14.275 8.09167 14.0417 7.93333 13.825 7.7ZM19.1 21.9L15.2 18C14.95 18.25 14.6083 18.4543 14.175 18.613C13.7417 18.771 13.35 18.8667 13 18.9V20C13 20.2833 12.9043 20.5207 12.713 20.712C12.521 20.904 12.2833 21 12 21C11.7167 21 11.4793 20.904 11.288 20.712C11.096 20.5207 11 20.2833 11 20V18.85C10.25 18.6667 9.59601 18.3543 9.03801 17.913C8.47935 17.471 8.03335 16.9167 7.70001 16.25C7.56668 16 7.55835 15.7333 7.67501 15.45C7.79168 15.1667 8.00001 14.9667 8.30001 14.85C8.55001 14.75 8.80835 14.75 9.07501 14.85C9.34168 14.95 9.55001 15.1417 9.70001 15.425C9.95001 15.8917 10.2833 16.2707 10.7 16.562C11.1167 16.854 11.6167 17 12.2 17C12.5 17 12.775 16.9623 13.025 16.887C13.275 16.8123 13.5167 16.7 13.75 16.55L2.10001 4.9C1.91668 4.71667 1.82501 4.48333 1.82501 4.2C1.82501 3.91667 1.91668 3.68333 2.10001 3.5C2.28335 3.31667 2.51668 3.225 2.80001 3.225C3.08335 3.225 3.31668 3.31667 3.50001 3.5L20.5 20.5C20.6 20.6 20.671 20.7083 20.713 20.825C20.7543 20.9417 20.775 21.0667 20.775 21.2C20.775 21.3333 20.7543 21.4583 20.713 21.575C20.671 21.6917 20.6 21.8 20.5 21.9C20.3167 22.0833 20.0833 22.175 19.8 22.175C19.5167 22.175 19.2833 22.0833 19.1 21.9Z"
        fill="#6A7880"
      />
    </g>
  </svg>
);

export default NoMoneyIcon;
